module.exports = __webpack_public_path__ + "media/images/item/btn_rumor-bf9850db19a6b61686ae07b37dabf705.png";